import * as t from '../actionTypes';

export const accessTaskSuccess = data => ({
  type: t.ACCESS_TASK_SUCCESS,
  payload: data
});

export const accessTaskFailed = error => ({
  type: t.ACCESS_TASK_FAILED,
  payload: error
});
